import { render, staticRenderFns } from "./settings-expand.vue?vue&type=template&id=7bbbc7be&scoped=true&"
import script from "./settings-expand.vue?vue&type=script&lang=js&"
export * from "./settings-expand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbbc7be",
  null
  
)

export default component.exports